import { render, staticRenderFns } from "./space_list_subscribed_item.vue?vue&type=template&id=ae5c450c&scoped=true&lang=pug"
import script from "./space_list_subscribed_item.vue?vue&type=script&lang=js"
export * from "./space_list_subscribed_item.vue?vue&type=script&lang=js"
import style0 from "./space_list_subscribed_item.vue?vue&type=style&index=0&id=ae5c450c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5c450c",
  null
  
)

export default component.exports